const S4WarningDrugList = [
  "Nurofen Plus",
  "Amylobarbitone",
  "Amobarbital",
  "Anabolic and androgenic steroidal agents",
  "Androisoxazole",
  "Barbiturates",
  "Benzodiazepine derivatives",
  "Benzphetamine",
  "Bolandiol",
  "Bolasterone",
  "Boldenone",
  "Bolmantalate",
  "Calusterone",
  "Cathine",
  "Chlorandrostenolone",
  "Chloroxydienone",
  "Chloroxymesterone",
  "Clostebol",
  "Darbepoetin",
  "Dextropropoxyphene",
  "Diethylpropion",
  "Dihydrolone",
  "Dimethandrostanolone",
  "Dimethazine",
  "Doxapram",
  "Drostanolone",
  "Enobosarm",
  "Ephedrine",
  "Epoetins",
  "Erythropoietins",
  "Ethchlorvynol",
  "Ethinamate",
  "Ethyldienolone",
  "Ethyloestrenol",
  "Fencamfamin",
  "Fenproporex",
  "Fluoxymesterone",
  "Flurazepam",
  "Follistatin",
  "Formebolone",
  "Formyldienolone",
  "Furazabol",
  "Glutethimide",
  "Hydroxystenozol",
  "Insulin-like growth factors",
  "Mazindol",
  "Medazepam",
  "Mefenorex",
  "Meprobamate",
  "Mesabolone",
  "Mestanolone",
  "Mesterolone",
  "Methandienone",
  "Methandriol",
  "Methenolone",
  "Methylandrostanolone",
  "Methylclostebol",
  "Methylphenobarbitone",
  "Methyltestosterone",
  "Methyltrienolone",
  "Methyprylone",
  "Mibolerone",
  "Midazolam",
  "Nalbuphine",
  "Nandrolone",
  "Nitrazepam",
  "Norandrostenolone",
  "Norbolethone",
  "Norethandrolone",
  "Normethandrone",
  "Oxabolone",
  "Oxandrolone",
  "Oxymesterone",
  "Oxymetholone",
  "Paraldehyde",
  "Pentobarbitone",
  "Phenobarbitone",
  "Pipradrol",
  "Prasterone",
  "Prazepam",
  "Propylhexedrine",
  "Pseudoephedrine",
  "Pyrovalerone",
  "Quinbolone",
  "Selective androgen receptor modulators",
  "Silandrone",
  "Somatropin",
  "Stanolone",
  "Stanozolol",
  "Stenbolone",
  "Testolactone",
  "Testosterone",
  "Thiomesterone",
  "Trenbolone",
  "Trestolone",
  "Zolazepam",
];

export default S4WarningDrugList;